import React from "react";
import { OperationsDashboard } from "../components/OperationsDashboard";
import { CustomDashboardProps } from "../utils/types";

export const dashboard: CustomDashboardProps = {
  title: "Win-Loss Analysis Dashboard",
  charts: [],
  filters: [],
  Component: () =>
    React.createElement(OperationsDashboard, {
      variant: "win_loss_analysis",
    }),
};
